import React from "react";
import BehiveCell from "./BehiveCell";

const getWidthCSSClass = (width) => {
  let CSSClass = "";
  switch (width) {
    case 4:
      CSSClass = "w-full";
      break;
    case 2.6:
      CSSClass = "w-2/3";
      break;
    case 2:
      CSSClass = "w-1/2";
      break;
    case 1.3:
      CSSClass = "w-1/3";
      break;
    case 1:
      CSSClass = "w-1/4";
      break;
    default:
      CSSClass = "w-1/4";
      break;
  }
  return CSSClass;
};

const alignDiff = (cols) => {
  let align = cols[0].align;
  for (let c = 1; c < cols.length; c++) {
    if (cols[c].align !== align) {
      align = "diff";
    }
  }
  return align;
};

const getRowAlignment = (row) => {
  if (row.cols.length === 1) {
    if (row.cols[0].align === "left") {
      return "start";
    }
    if (row.cols[0].align === "right") {
      return "end";
    }
  }

  if (row.cols.length > 1 && row.cols.length < 4) {
    const align = alignDiff(row.cols);
    if (align === "diff") {
      return "between";
    }

    if (align === "left") {
      return "start";
    }

    if (align === "right") {
      return "end";
    }
  }
  return "center";
};

const BehiveLayout = (props) => {
  const { layout, data, behaviourCardClickThroughHandler } = props;

  return layout ? (
    layout.sections.map((section, index) => (
      <div className="mt-6 mx-6" key={`section-${index}`}>
        <div className="font-extrabold text-2xl mb-6">{section.title}</div>
        <div>
          {section.rows.map((row, index) => (
            <div
              className={`w-full flex justify-${getRowAlignment(row)} items-stretch mb-6 gap-x-6`}
              key={`row-${index}`}
            >
              {row.cols.map((col, index) => (
                <div
                  key={`col-${index}`}
                  className={`${getWidthCSSClass(parseFloat(col.width))} flex flex-col items-stretch box-border`}
                >
                  <BehiveCell
                    layoutInfo={col}
                    data={data}
                    rowLength={row.cols.length}
                    behaviourCardClickThroughHandler={
                      behaviourCardClickThroughHandler
                    }
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    ))
  ) : (
    <div>No Layout</div>
  );
};
export default BehiveLayout;
